import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=5d227a15"
import script from "./Test.vue?vue&type=script&lang=ts"
export * from "./Test.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports